import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = ["fill"]
const _hoisted_3 = ["fill"]
const _hoisted_4 = ["fill"]
const _hoisted_5 = ["fill"]
const _hoisted_6 = ["fill"]
const _hoisted_7 = ["fill"]
const _hoisted_8 = ["fill"]
const _hoisted_9 = ["fill"]
const _hoisted_10 = ["fill"]
const _hoisted_11 = ["fill"]
const _hoisted_12 = ["fill"]
const _hoisted_13 = ["fill"]
const _hoisted_14 = ["fill"]
const _hoisted_15 = ["fill"]

import { withDefaults } from 'vue';

interface IProps {
    color?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CpuIcon',
  props: {
    color: null
  },
  setup(__props: any) {

const props = __props as { color?: string };



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      opacity: "0.4",
      d: "M15 4H9C6.24 4 4 6.24 4 9V15C4 17.76 6.24 20 9 20H15C17.76 20 20 17.76 20 15V9C20 6.24 17.76 4 15 4ZM17.26 14.26C17.26 15.92 15.92 17.26 14.26 17.26H9.74C8.08 17.26 6.74 15.92 6.74 14.26V9.74C6.74 8.08 8.08 6.74 9.74 6.74H14.25C15.91 6.74 17.25 8.08 17.25 9.74V14.26H17.26Z",
      fill: __props.color || '#7E8695'
    }, null, 8, _hoisted_2),
    _createElementVNode("path", {
      d: "M9.06006 2.75V4H9.00006C8.50006 4 8.02006 4.07 7.56006 4.21V2.75C7.56006 2.34 7.89006 2 8.31006 2C8.72006 2 9.06006 2.34 9.06006 2.75Z",
      fill: __props.color || '#7E8695'
    }, null, 8, _hoisted_3),
    _createElementVNode("path", {
      d: "M12.75 2.75V4H11.25V2.75C11.25 2.34 11.59 2 12 2C12.41 2 12.75 2.34 12.75 2.75Z",
      fill: __props.color || '#7E8695'
    }, null, 8, _hoisted_4),
    _createElementVNode("path", {
      d: "M16.45 2.75V4.21C15.99 4.07 15.5 4 15 4H14.95V2.75C14.95 2.34 15.29 2 15.7 2C16.11 2 16.45 2.34 16.45 2.75Z",
      fill: __props.color || '#7E8695'
    }, null, 8, _hoisted_5),
    _createElementVNode("path", {
      d: "M22 8.3C22 8.72 21.67 9.05 21.25 9.05H20V9C20 8.5 19.93 8.01 19.79 7.55H21.25C21.67 7.55 22 7.89 22 8.3Z",
      fill: __props.color || '#7E8695'
    }, null, 8, _hoisted_6),
    _createElementVNode("path", {
      d: "M22 12C22 12.41 21.67 12.75 21.25 12.75H20V11.25H21.25C21.67 11.25 22 11.58 22 12Z",
      fill: __props.color || '#7E8695'
    }, null, 8, _hoisted_7),
    _createElementVNode("path", {
      d: "M22 15.7C22 16.11 21.67 16.45 21.25 16.45H19.79C19.93 15.99 20 15.5 20 15V14.95H21.25C21.67 14.95 22 15.28 22 15.7Z",
      fill: __props.color || '#7E8695'
    }, null, 8, _hoisted_8),
    _createElementVNode("path", {
      d: "M16.45 19.79V21.25C16.45 21.66 16.11 22 15.7 22C15.29 22 14.95 21.66 14.95 21.25V20H15C15.5 20 15.99 19.93 16.45 19.79Z",
      fill: __props.color || '#7E8695'
    }, null, 8, _hoisted_9),
    _createElementVNode("path", {
      d: "M12.76 20V21.25C12.76 21.66 12.42 22 12.01 22C11.59 22 11.26 21.66 11.26 21.25V20H12.76Z",
      fill: __props.color || '#7E8695'
    }, null, 8, _hoisted_10),
    _createElementVNode("path", {
      d: "M9.06006 20V21.25C9.06006 21.66 8.72006 22 8.31006 22C7.89006 22 7.56006 21.66 7.56006 21.25V19.79C8.02006 19.93 8.50006 20 9.00006 20H9.06006Z",
      fill: __props.color || '#7E8695'
    }, null, 8, _hoisted_11),
    _createElementVNode("path", {
      d: "M4.21 7.55C4.07 8.01 4 8.5 4 9V9.05H2.75C2.34 9.05 2 8.72 2 8.3C2 7.89 2.34 7.55 2.75 7.55H4.21Z",
      fill: __props.color || '#7E8695'
    }, null, 8, _hoisted_12),
    _createElementVNode("path", {
      d: "M4 11.25V12.75H2.75C2.34 12.75 2 12.41 2 12C2 11.58 2.34 11.25 2.75 11.25H4Z",
      fill: __props.color || '#7E8695'
    }, null, 8, _hoisted_13),
    _createElementVNode("path", {
      d: "M4.21 16.45H2.75C2.34 16.45 2 16.11 2 15.7C2 15.28 2.34 14.95 2.75 14.95H4V15C4 15.5 4.07 15.99 4.21 16.45Z",
      fill: __props.color || '#7E8695'
    }, null, 8, _hoisted_14),
    _createElementVNode("path", {
      d: "M17.26 9.74V14.25C17.26 15.91 15.92 17.25 14.26 17.25H9.73999C8.07999 17.25 6.73999 15.91 6.73999 14.25V9.74C6.73999 8.08 8.07999 6.74 9.73999 6.74H14.25C15.91 6.74 17.26 8.09 17.26 9.74Z",
      fill: __props.color || '#7E8695'
    }, null, 8, _hoisted_15)
  ]))
}
}

})